import * as moment from 'moment';
import config from '../../configs/config';
import { generateGuid } from '../../util/stringHelper';
import { getApiKey, makeApiGatewayCall, makeApiNonGatewayCall, getUserId } from '../common/apiUtils';
import { IBlobFileUploadResponse } from './model';

const getRepeatedDate = () => moment().format('YYYYMMDDYYYYMMDDYYYYMMDDYYYYMMDD');

export const uploadFile = ({ file }: { file: File }) => {
	const data: FormData = new FormData();

	data.append('0', file);

	data.append('UserId', getRepeatedDate());
	data.append('BlobUploadId', generateGuid());
	data.append('Storage', 'S3');

	return makeApiGatewayCall<IBlobFileUploadResponse>(config.blob_service.file_upload + '?Storage=S3', 'post', data);
};

export const uploadOperationsFile = ({ file }: { file: File }) => {
	const nameArr = file.name.split('.');
	nameArr[0] = Date.now().toString();
	const newFile = new File([file], nameArr.join('.'));

	const data: FormData = new FormData();
	const userId = getUserId();
	data.append('file', newFile);
	data.append('userId', userId!);
	data.append('Storage', 'priv');

	return makeApiGatewayCall<IBlobFileUploadResponse>(
		config.blob_service.import_file_upload,
		// config.blob_service.file_upload + '?userId=' + userId,
		'post',
		data
	);
};

export const uploadBlob = (str: string, filename: string) => {
	const blob = new Blob([str]);
	const file = new File([blob], filename);
	const data: FormData = new FormData();

	data.append('0', file);

	data.append('UserId', getRepeatedDate());
	data.append('BlobUploadId', generateGuid());
	data.append('Storage', 'S3');

	return makeApiGatewayCall<IBlobFileUploadResponse>(config.blob_service.file_upload + '?Storage=S3', 'post', data);
};

export const uploadOldImportFile = async ({ file }: { file: File }) => {
	const data: FormData = new FormData();

	data.append('file', file);

	const response = await fetch(config.blob_service.old_file_upload + '?apikey=' + getApiKey(), {
		body: data,
		method: 'post',
	});

	const json = await response.json();

	return { data: json };
};
export const importOldImportUrl = async ({ url }: { url: string }) => {
	const response = await fetch(
		config.blob_service.old_url_upload + '?format=json&mode=view' + '&apikey=' + getApiKey() + '&url=' + encodeURIComponent(url)
	);

	const json = await response.json();

	return { data: json };
};
